import { Injectable } from '@angular/core';
import { BydUserRightsEnum } from '@sixense/ds-roazhon-service';

@Injectable({
  providedIn: 'root',
})
export class DsRightsManagerService {
  /**
   * List of rights for the current user and project.
   */
  public rights: BydUserRightsEnum[] = [];

  /**
   * Resets the array of rights.
   */
  public resetRights() {
    this.rights = [];
  }

  /**
   * Adds a right to the list.
   *
   * @param right Right to add
   */
  public addRight(right: BydUserRightsEnum) {
    if (!this.rights.includes(right)) {
      this.rights.push(right);
    }
  }

  /**
   * Sets the rights to be the array given in parameter.
   *
   * @param rights List of rights to set
   */
  public setRights(rights: BydUserRightsEnum[]) {
    this.rights = rights;
  }

  /**
   * Checks if the user has a right.
   *
   * @param right right to check
   * @returns boolean
   */
  public hasRight(right: number): boolean {
    return this.rights.includes(right);
  }
}
